import { useState } from 'react';
import { useArea } from '../../../features/area/useArea';

export const useOnSavePostClicked = (formState = {}) => {
    const { create } = useArea();
    const [response, setResponse] = useState();
    const [loading, setLoading] = useState(false);
    const [formError, setformError] = useState();

    const onSavePostClicked = async () => {
        setLoading(true);
        try {
            const formData = {
                name: formState.name
            };
            const response = await create(formData);
            setResponse(response);
            setformError(response.errors)
        } catch (error) {
            const errorResponse = error?.response?.data || { message: 'Bilinmeyen hata oluştu' };
            setResponse(errorResponse);
            return errorResponse;
        } finally {
            setLoading(false);
        }
    };

    return {
        response,
        loading,
        formError,
        onSavePostClicked,
    };
};
